import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import Onboarding from '../../pages/onboarding/OnBoarding';

export default function AddCoachDialog({
  open,
  handleClose,
  userRole,
  isEdit,
  
  edifierToEditData,
  setEdifierToEditData,
  userToken,
  queryClient,
}) {
  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="lg"
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiPaper-root': {
            height: 'max-content',
            borderRadius: '20px',
            minWidth: { xs: '100%', md: 'fit-content' },
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '20px' }}>
          <Typography variant="h4" sx={{ color: 'text.titles' }}>
            {isEdit
              ? edifierToEditData?.role?.toLowerCase() === 'teacher'
                ? 'Modify Teacher Data'
                : 'Modify Edifier Data'
              : 'Add Edifier'}
          </Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
        </Box>
        <DialogContent sx={{ p: { xs: '0 !important', sm: 'inherit' } }}>
          {!isEdit && (
            <Onboarding handleClose={handleClose} userRole={userRole} isOnlyEdifier queryClient={queryClient} />
          )}
          
          {isEdit && (
            <Onboarding
              handleClose={handleClose}
              userRole={userRole}
              edifierToEditData={edifierToEditData}
              setEdifierToEditData={setEdifierToEditData}
              userToken={userToken}
              isOnlyEdifier={!edifierToEditData ? true : edifierToEditData?.role?.toLowerCase() === 'coach'}
              queryClient={queryClient}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
